'use client';
import { SWAN_VERSION } from '../constants/paths.js';

const SWAN_VERSION_META_NAME = 'swanVersion';
function createSwanVersionMetaTag() {
    if ('undefined' != typeof window && !document.querySelector('meta[name="swanVersion"]')) {
        let n = document.createElement('meta');
        n.name = 'swanVersion', n.content = SWAN_VERSION, document.head.appendChild(n);
    }
}
function createSwanGlobalObject(n) {
    'undefined' != typeof window && (window.__swan = {
        version: SWAN_VERSION,
        swanBaseUrl: n
    });
}

export { SWAN_VERSION_META_NAME, createSwanGlobalObject, createSwanVersionMetaTag };
